import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/';

if (!baseURL) {
  console.error(
    'Base URL is not defined. Please set VUE_APP_API_BASE_URL in your .env file.'
  );
}

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export { api };
